import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get Campuses
export const ListCampus = createAsyncThunk('Campus-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/campus/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampus = createAsyncThunk('Campus-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/campus/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus id
export const editCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/campus/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewCampus = createAsyncThunk('Campus-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/campus/show/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Campus
export const deleteCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/campus/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus Managers
export const ListCampusManager = createAsyncThunk(
  'Campus-manager-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/campus-manager/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Campus Manager
export const createCampusManager = createAsyncThunk(
  'Campus-manager-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/campus-manager/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error)
      }
    }
  }
)

// Get Campus Manager id
export const editCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/campus-manager/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Active Campus Manager
export const activeCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/campus-manager/active/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Inactive Campus Manager
export const inactiveCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/campus-manager/inactive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses
export const ListCampusGrading = createAsyncThunk('campus-grading-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/campus-grading/list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampusGrading = createAsyncThunk(
  'campus-grading-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/campus-grading/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campus id
export const editCampusGrading = createAsyncThunk(
  'campus-grading-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/campus-grading/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses
export const ListCampusBank = createAsyncThunk('Campus-bank-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/campus-bank/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampusBank = createAsyncThunk(
  'Campus-bank-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/campus-bank/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campus id
export const editCampusBank = createAsyncThunk('Campus-bank-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/campus-bank/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Campus
export const deleteCampusBank = createAsyncThunk(
  'Campus-bank-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/campus-bank/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type CampusState = {
  record: any
  records: any
  errors: any
}

const initialState: CampusState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const campusSlice = createSlice({
  name: 'campus',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListCampus.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editCampus.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListCampusManager.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editCampusManager.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(createCampusGrading.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCampusBank.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCampusBank.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = campusSlice.actions
export default campusSlice.reducer
